import React from 'react';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid';

export default function SortableTh({
  children,
  label,
  sortKey,
  currentSort,
  sortConfig,
  onSort,
  className = ''
}) {
  const resolvedSort = currentSort || sortConfig || { key: null, direction: null };
  const headerLabel = children || label || '';
  const isSorted = resolvedSort?.key === sortKey;
  const direction = resolvedSort?.direction;

  const handleSort = () => {
    if (typeof onSort === 'function' && sortKey) {
      onSort(sortKey);
    }
  };

  const ariaSort = isSorted ? (direction === 'asc' ? 'ascending' : 'descending') : 'none';

  return (
    <th scope="col" aria-sort={ariaSort} className={className}>
      <button
        type="button"
        className="group inline-flex w-full items-center gap-1 text-left"
        onClick={handleSort}
      >
        <span>{headerLabel}</span>
        <span className={`flex-none rounded ${isSorted ? 'text-indigo-600' : 'text-gray-400 invisible group-hover:visible'}`}>
          {isSorted && direction === 'asc' ? (
            <ChevronUpIcon className="h-4 w-4" aria-hidden="true" />
          ) : (
            <ChevronDownIcon className="h-4 w-4" aria-hidden="true" />
          )}
        </span>
      </button>
    </th>
  );
}
